import React from "react";

export const DEFAULT_TEXT_MAX_WORDS = 100;
export const MAX_TEXT_MAX_WORDS = 1000;
export const validTextMaxWords = value => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= MAX_TEXT_MAX_WORDS;

export default function ProductUpdateTextLength({ value, onChange }) {
  const id = React.useId();
  return <div className="pu-text-length">
    <label>Longueur maximale (mots)<input type="number" min={1} max={MAX_TEXT_MAX_WORDS} step={1}
      value={value} aria-describedby={id} aria-invalid={!validTextMaxWords(value)} onChange={event => onChange(event.target.value)} /></label>
    <small id={id}>{validTextMaxWords(value) ? "Par nouveauté, explication et exemple compris." : `Saisissez un nombre entier entre 1 et ${MAX_TEXT_MAX_WORDS}.`}</small>
  </div>;
}
